import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Register, User, Office, Login,AccountHeadDetails,AccountSubHeadDetails,Expenditure,SainikSchemeApplicationModel,SainikSchemeApplicationStatusHistoryModel,CorrespondanceTrackingModel,GrievancesLodging } from './shared/user.model';

@Injectable()
export class RegistrationService {
//baseurl:string;
httpOptions: any;

 //readonly baseurl="http://localhost:14055/";
  //readonly baseurl="http://sainikapi.esdinfra.com/";

  readonly baseurl="https://sainikstagingapi.esdinfra.com/";

//readonly baseurl="http://uatsainikapi.esdinfra.com/";
//readonly baseurl="http://106.51.65.164:96/"; //latest dell
//readonly baseurl="http://10.10.31.183.81/"; // live api url
  // readonly baseurl="http://10.10.31.183:81/"; //Data center
 //readonly baseurl="http://103.138.196.173:81/"; //Public Data center
 //readonly baseurl="http://10.10.135.178:81/"; //live api url (internal) //02-11-2022 

 //readonly baseurl="http://103.138.196.173:81/"; // live api url (public) //10-11-2022
  
  constructor(public http: HttpClient) {
   let accesstoken = localStorage.getItem('accessToken');
   if (accesstoken != null && accesstoken != '' && typeof (accesstoken) != undefined) {
     this.httpOptions = {
       headers: new HttpHeaders({
         'Content-Type': 'application/json',
         'Authorization': 'Bearer ' + accesstoken,
         'No-Auth': 'True'
       })
     };
   }
   }

   getAllowedPages() {
    let accesstoken = localStorage.getItem('accessToken');
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + accesstoken
      })
    };
    return this.http.get(this.baseurl + 'api/AllowedPages', this.httpOptions);
  }
    doregister(data:any){    
    return this.http.post(this.baseurl+"api/SainikRegistrationDEForm",data,this.httpOptions);
  }

  uploadImage(data){    
    console.log(data);
    return this.http.post(this.baseurl+"api/SainikRegistration/image",data);
  }
  getfinalize(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetFinalizedData/"+SR_ServiceNo,this.httpOptions);
  }
  getIdCardNumbers()
  {
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetIdCardNumbers/",this.httpOptions);
  }
  getRegiments()
  {
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetSainikRegiments/",this.httpOptions);
  }
  getDaughterNamesForDropdown(serviceNo:any)
  {
    return this.http.get(this.baseurl+"api/SainikSchemes/GetDaughterNamesForDropdown/"+serviceNo,this.httpOptions);
  }

  getfinalizedDataForAwards(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikAwards/GetFinalizedDataForAwards/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizedDataForBattle(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetFinalizedDataForBattle/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeforDependents(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikDependents/GetfinalizeforDependents/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeForPension(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikPension/GetfinalizeForPension/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeForUploads(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikUploads/GetfinalizeForUploads/"+SR_ServiceNo,this.httpOptions);
  }
  getfinalizeForReports(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikReports/GetfinalizeForReports/"+SR_ServiceNo,this.httpOptions);
  }

  getfinalizeForBankInfo(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetfinalizeForBankInfo/"+SR_ServiceNo,this.httpOptions);
  }
  getSainikDetails(SR_ServiceNo:any){  
  debugger;  
  return this.http.get(this.baseurl+"api/SainikRegistration/GetDetails"+SR_ServiceNo,this.httpOptions);
  }

  checkSainikExist(SR_ServiceNo:any){  
    debugger;  
    return this.http.get(this.baseurl+"api/SainikRegistration/CheckServiceNoExist/"+SR_ServiceNo,this.httpOptions);
  }


  getAllRanks(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRanks",this.httpOptions);
  }

  getAllCorps(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllCorps",this.httpOptions);
  }

  getRankLevels(SR_Corps:any,SR_Rank:any,HonoraryRank:any){
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRankLevels/"+ SR_Corps +"/" +SR_Rank+"/"+HonoraryRank,this.httpOptions);
  }

  getAllQualification(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllQualifications",this.httpOptions);
  }

  getAllCivilTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllCivilTypes",this.httpOptions);
  }

  getAllEquivalentTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllEquivalentTypes",this.httpOptions);
  }

  getAllServiceTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllServiceTypes",this.httpOptions);
  }

  getAllServiceCategories(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllServiceCategories",this.httpOptions);
  }

  getAllRelegions(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRelegions",this.httpOptions);
  }

  getAllCaste(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllCaste",this.httpOptions);
  }

  getAllRelations(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllRelations",this.httpOptions);
  }

  getAllOccupationTypes(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetAllOccupationTypes",this.httpOptions);
  }

  getRecordOfficeDetailsForBasicRegistration(SR_Station_Id_FK){    
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetRecordOfficeDetailsForBasicRegistration/"+SR_Station_Id_FK,this.httpOptions);
  }

  getAllDocumentTypes(){    
    return this.http.get(this.baseurl+"api/SainikUploads/GetAllDocumentTypes",this.httpOptions);
  }
  getAllReports(){    
    return this.http.get(this.baseurl+"api/SainikReportsGetAllDocumentTypes",this.httpOptions);
  }
  getAllStates(enteredText:any){    
    return this.http.get(this.baseurl+"api/State/speedsearch/"+ enteredText,this.httpOptions);
  }
  getAllDistricts(enteredText:any){    
    return this.http.get(this.baseurl+"api/District/speedsearch/"+ enteredText,this.httpOptions);
  }
  getAllTaluks(enteredText:any){    
    return this.http.get(this.baseurl+"api/Taluk/speedsearch/"+ enteredText,this.httpOptions);
  }
  getAllVillages(enteredText:any){    
    return this.http.get(this.baseurl+"api/Village/speedsearch/"+ enteredText,this.httpOptions);
  }
  //
  getStates(){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetStates",this.httpOptions);
  }
  getDistricts(stateId){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetDistricts/"+stateId,this.httpOptions);
  }
  getTaluks(districtId){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetTaluks/"+districtId,this.httpOptions);
  }
  getVillages(talukId){    
    return this.http.get(this.baseurl+"api/SainikRegistration/GetVillages/"+talukId,this.httpOptions);
  }

  getAllPensionTypes(IsPensioner){    
    return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionTypes/"+IsPensioner,this.httpOptions);
  }

  getAllPensionCategory(pensionTypeId:any){    
            return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionCategory/" + pensionTypeId,this.httpOptions);
  }
  getAllPensionCategies(){    
    return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionCategies" ,this.httpOptions);
}

  
  getAllMilitaryQualifications(){    
    return this.http.get(this.baseurl+"api/SainikPension/GetAllMilitaryQualifications",this.httpOptions);
  }

  //issuing authority dropdown
  getPensionIssuingAuthorityForDropdown(){    
    return this.http.get(this.baseurl+"api/SainikPension/GetPensionIssuingAuthorityForDropdown",this.httpOptions);
  }

  //Save Basic registration
  saveBasicRegistration(data:any){    
    return this.http.post(this.baseurl+"api/SainikRegistrationDEForm",data,this.httpOptions);
  }

  saveSainikBasicRegistration(data:any){    
    return this.http.post(this.baseurl+"api/SainikBasicRegistration",data,this.httpOptions);
  }

  insertFinalize(SR_ServiceNo){    
    return this.http.post(this.baseurl+"api/SainikBasicRegistration/InsertFinalizeData/"+SR_ServiceNo,this.httpOptions);
  }

  getAllAwardsMasters(){
    return this.http.get(this.baseurl+"api/SainikAwards/GetAllAwardsMasters",this.httpOptions);
  }
  getAllAwardTypes(){
    return this.http.get(this.baseurl+"api/SainikAwards/getAllAwardTypes",this.httpOptions);
  }

  getAllCasualtyType(){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/CasualtyTypes",this.httpOptions);
  }
  //year dropdown
  getYearDropdownForBattleCasualty(){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetYearDropdownForBattleCasualty",this.httpOptions);
  }

  getSainikBasicDetailsForAwards(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikAwards/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }
  
  getSainikBasicDetailsForBattle(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikBasicDetailsForDependents(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikDependents/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikBasicDetailsForBanks(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikBasicDetailsForBasicRegistration(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
  }

  getSainikDetailsFromRegistration(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetDetailsFromRegistration/"+SR_ServiceNo,this.httpOptions);
  }
  
  getSainikBasicDetailsForUploads(SR_ServiceNo){
  return this.http.get(this.baseurl+"api/SainikUploads/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
   }
  getSainikBasicDetailsForReports(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikReports/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
     }

   getSainikBasicDetailsForPension(SR_ServiceNo){
    return this.http.get(this.baseurl+"api/SainikPension/GetSainikDetails/"+SR_ServiceNo,this.httpOptions);
     }

     deleteDependent(Did:any){
     return this.http.put(this.baseurl+"api/SainikDependents/DeleteDependent/"+Did,null,this.httpOptions);
    }

    deleteUpload(DuploadId:any){
      return this.http.put(this.baseurl+"api/SainikUploads/DeleteUpload/"+DuploadId,null,this.httpOptions);
     }

     
  //Save Battle Casualty
  saveBattleCasualty(serviceNo:any,sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    ///debugger;
  //console.log(data);
    return this.http.post(this.baseurl+"api/SainikBattleCasualty/"+serviceNo+"/",data,this.httpOptions);
  }

  updateBattleCasualty(serviceNo:any,sainikId:any,data:any){ 
    data['SBC_SR_Id_FK'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikBattleCasualty/Update/"+serviceNo+"/",data,this.httpOptions);
  }

  UpdateSainikPension(sainikId:any,data:any){ 
    data['SP_SR_Id_FK'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikPension/Update",data,this.httpOptions);
  }

  updateBasicRegistration(sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikBasicRegistration/Update",data,this.httpOptions);
  }

  saveDependents(sainikId:any,data:any){ 
    debugger;
    return this.http.post(this.baseurl+"api/SainikDependents/"+sainikId, data,this.httpOptions);
  }

  updateDependents(sainikId:any,data:any){ 
    debugger;
    return this.http.post(this.baseurl+"api/SainikDependents/Update"+sainikId, data,this.httpOptions);
  }

  saveSainikAwards(sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    return this.http.post(this.baseurl+"api/SainikAwards",data,this.httpOptions);
  }

  saveSainikPension(sainikId:any,data:any){    
    data['SP_SR_Id_FK'] = sainikId;
    return this.http.post(this.baseurl+"api/SainikPension",data,this.httpOptions);
  }

  updateSainikAwards(sainikId:any,data:any){ 
    data['SR_Id'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikAwards/Update",data,this.httpOptions);
  }

  saveSainikBankDetails(sainikId:any,data:any){ 
    data['SBD_SR_Id_FK'] = sainikId;
    return this.http.post(this.baseurl+"api/SainikBankDetails",data,this.httpOptions);
  }

  updateSainikBankDetails(sainikId:any,data:any){ 
    data['SBD_SR_Id_FK'] = sainikId;
    return this.http.put(this.baseurl+"api/SainikBankDetails/Update",data,this.httpOptions);
  }

  saveSainikUploads(serviceNo:any,sainikId:any,data:any){ 
    debugger;
    data['SDU_SR_Id_FK'] = sainikId;
   // return this.http.post(this.baseurl+"api/SainikUploads/Insert/sainikId",data,this.httpOptions);
   //return this.http.post(this.baseurl+"api/SainikUploads",data,this.httpOptions);
   return this.http.post(this.baseurl+"api/SainikUploads/"+serviceNo+"/"+sainikId,data,this.httpOptions);
  }

  saveSainikReports(serviceNo:any,sainikId:any,data:any){ 
    debugger;
    data['SDU_SR_Id_FK'] = sainikId;
   // return this.http.post(this.baseurl+"api/SainikReports/Insert/sainikId",data,this.httpOptions);
   //return this.http.post(this.baseurl+"api/SainikReports",data,this.httpOptions);
   return this.http.post(this.baseurl+"api/SainikReports/"+serviceNo+"/"+sainikId,data,this.httpOptions);
  }

  updateReports(sainikId:any,data:any){ 
    debugger;
    return this.http.post(this.baseurl+"api/SainikReports/Update"+sainikId, data,this.httpOptions);
  }


  //sainik bank details
  getAllBanks(){    
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetAllBanks",this.httpOptions);
  }

  getAllBankBranches(BankId){    
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetAllBankBranches/"+BankId,this.httpOptions);
  }

  getAllBankAccountOf(){    
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetAllBankAccountOf",this.httpOptions);
  }

  getIFSC(BranchId){
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetIFSC/"+BranchId,this.httpOptions);
  }

  getSainikCompleteDetails(SR_ServiceNo:any){    
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetSainikViewForm/"+SR_ServiceNo,this.httpOptions);
  }

//Authorization and Authentication methods

  getAllRoles(itemsPerPage: number, pageNo: number) {
    debugger;
    return this.http.get(this.baseurl + 'api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  getAllUsers(itemsPerPage: number, pageNo: number) {
    debugger;
    return this.http.get(this.baseurl + 'api/Users/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  getAllClaimsForTheRole(roleId: string) {
    return this.http.get(this.baseurl + 'api/Claims/' + roleId, this.httpOptions);
  }
  getRoleForTheId(roleId: string) {
    return this.http.get(this.baseurl + 'api/Roles/' + roleId, this.httpOptions);
  }

  getUserForTheId(Id: string) {
    return this.http.get(this.baseurl + 'api/Users/' + Id, this.httpOptions);
  }
  
  getOfficeForTheId(OfficeId: string) {
       return this.http.get(this.baseurl + 'api/Offices/' + OfficeId, this.httpOptions);
  }

  getAllClaims(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.baseurl + 'api/Roles/GetAll/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }

  GetAllRoleNames() {
    return this.http.get(this.baseurl + 'api/Roles/GetAllOffices/', this.httpOptions);
  }

  GetAllOfficelevels() {
    return this.http.get(this.baseurl + 'api/Offices/GetOfficelevel/', this.httpOptions);
  }
  
  GetAllDistrictNames() {
    return this.http.get(this.baseurl + 'api/Offices/GetDistrict/', this.httpOptions);
  }

  getAllDistrictName() {
    debugger;
    return this.http.get(this.baseurl + 'api/Users/GetAllDistrict', this.httpOptions);
  }

  getRolesforSelectedOffice() {

    return this.http.get(this.baseurl + 'api/Roles/getRolesforSelectedOffice', this.httpOptions);
  }

  GetAllOffices(itemsPerPage:number,pageNo:number) {
    debugger;
    return this.http.get(this.baseurl + 'api/Offices/GetAll/' +itemsPerPage+"/"+pageNo, this.httpOptions);
  }


  registerUser(register: Register) {
  debugger;
    return this.http.post(this.baseurl + 'api/Account/Register', register, this.httpOptions);
  }

  registerCustomer(register: Register) {
  
    return this.http.post(this.baseurl + 'api/CustomerAccount/Register', register, this.httpOptions);
  }

  forgetPassword (fp){
    return this.http.post(this.baseurl + 'api/CustomerAccount/ForgotPassword',fp,this.httpOptions);
  }

  createRole(user: User) {
    return this.http.post(this.baseurl + 'api/Roles/Create', user, this.httpOptions);
  }

  updateRole(user: User,roleId:string) {
    return this.http.put(this.baseurl + 'api/Roles/Update/'+roleId, user, this.httpOptions);
  }

  searchRoles(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
    return this.http.get(this.baseurl + 'api/Roles/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  } 
  
  searchUsers(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number,searchdetails:any) {
    searchdetails['searchCriteria']=searchCriteria;
    searchdetails['searchText']=searchText;
    searchdetails['itemsPerPage']=itemsPerPage
    searchdetails['pageNo']=pageNo
    return this.http.post(this.baseurl + 'api/Users/Search',searchdetails, this.httpOptions);
  } 

  // searchUsers(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number) {
  //   return this.http.get(this.baseurl + 'api/Users/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  // }  

  // searchOffices(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number) {
  //   return this.http.get(this.baseurl + 'api/Offices/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
  // }
  searchOffices(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number,searchdetails:any) {
    debugger;
    searchdetails['searchCriteria']=searchCriteria;
    searchdetails['searchText']=searchText;
    searchdetails['itemsPerPage']=itemsPerPage
    searchdetails['pageNo']=pageNo
    return this.http.post(this.baseurl + 'api/Offices/Search',searchdetails, this.httpOptions);
  }    

  updateOffice(office: Office,OfficeId:string) {
       return this.http.put(this.baseurl + 'api/Offices/Update/'+OfficeId, office, this.httpOptions);
  }

  saveClaims(claimsList, roleId) {
    return this.http.put(this.baseurl + 'api/Claims/' + roleId + '/assignClaims', claimsList, this.httpOptions);
  }

  CreateOffice(office: Office) {
    return this.http.post(this.baseurl + 'api/Offices/Create', office, this.httpOptions);
  }

  changePassword(userDetails:any){
    return this.http.post(this.baseurl + 'api/Account/ChangePassword', userDetails, this.httpOptions);
  }

  ResetPasswordPh(userDetails:any){
    return this.http.post(this.baseurl + 'api/CustomerAccount/ResetPasswordPh', userDetails, this.httpOptions);
  }
  ResetPassword(userDetails:any){
    return this.http.post(this.baseurl + 'api/CustomerAccount/ResetPassword', userDetails, this.httpOptions);
  }
  
  changePasswordForTheId(userDetails:any){
    return this.http.put(this.baseurl + 'api/Account/Update', userDetails, this.httpOptions);
  }

  deleteRole(id: string){
    return this.http.put(this.baseurl + 'api/Roles/Delete/'+id, this.httpOptions);
  }

  activateInactivateUser(id: string){
    return this.http.put(this.baseurl + 'api/Users/ActivateInactivate/'+id, null, this.httpOptions);
  }
  
  activateInactivateRoles(id: string){
    return this.http.put(this.baseurl + 'api/Roles/ActivateInactivate/'+id, null, this.httpOptions);
  }

  activateInactivateOffices(id: string){
    return this.http.put(this.baseurl + 'api/Offices/ActivateInactivate/'+id, null, this.httpOptions);
  }
  ConfirmedMail(user) {
    debugger;
    return this.http.post(this.baseurl + 'api/CustomerAccount/ConfirmEmail',user ,this.httpOptions);
  }
  getDistrictName() {
      debugger;
      return this.http.get(this.baseurl + 'api/Users/GetAllDistrict', this.httpOptions);
    }
  
    isServiceNoHavingPhone(serviceNo :string)
{
  return this.http.get(this.baseurl + 'api/CustomerAccount/CheckPhoneNumberAlreadyExist/' + serviceNo, this.httpOptions);
}
resendSMS(serviceNo :string)
{
  return this.http.get(this.baseurl + 'api/CustomerAccount/ResendSMS/' + serviceNo, this.httpOptions);
}
getAllAccountHeads(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/AccountHead/GetAllAccountHeads/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
searchAccountHead(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{  
  return this.http.get(this.baseurl + 'api/AccountHead/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
deleteAccountHead(accountHead:string)
{   
   return this.http.delete(this.baseurl + 'api/AccountHead/DeleteAccountHead/'+accountHead, this.httpOptions);
}
getAccountForAccountHead(AccountHeadCode:string)
{
  return this.http.get(this.baseurl+'api/AccountHead/GetAccountHeadByAccountHead/'+AccountHeadCode,this.httpOptions);    
}
updateAccountHead(accounthead : AccountHeadDetails) {
  debugger;
  return this.http.put(this.baseurl + 'api/AccountHead/UpdateAccountHead', accounthead, this.httpOptions);
}  
addAccountHead(accountDetails : AccountHeadDetails) {    
  return this.http.post(this.baseurl + 'api/AccountHead/Create', accountDetails, this.httpOptions);
}
searchAccountSubHead(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{  
  return this.http.get(this.baseurl + 'api/AccountSubHead/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
getAllAccountSubHeads(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/AccountSubHead/GetAllAccountSubHeads/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
deleteAccountSubHead(accountHead:string, accountSubHead:string)
{   
   return this.http.delete(this.baseurl + 'api/AccountSubHead/DeleteAccountSubHead/'+accountHead + "/" + accountSubHead, this.httpOptions);
}
GetAllAccountHeadValues()
 {
    return this.http.get(this.baseurl+'api/AccountHead/GetAllAccountHeads', this.httpOptions);
 }
 getAccountSubHeadByAccountHeadAndAccountSubHead(AccountHeadCode:number,AccountSubHeadCode:number)
{
  return this.http.get(this.baseurl+'api/AccountSubHead/GetAccountSubHeadByAccountHeadAndAccountSubHead/'+AccountHeadCode + "/" +AccountSubHeadCode,this.httpOptions);    
}
updateAccountSubHead(accountSubhead : AccountSubHeadDetails) {
  debugger;
  return this.http.put(this.baseurl + 'api/AccountSubHead/UpdateAccountSubHead', accountSubhead, this.httpOptions);
}   
addAccountSubHead(accountSubDetails : AccountSubHeadDetails) {    
  return this.http.post(this.baseurl + 'api/AccountSubHead/Create', accountSubDetails, this.httpOptions);
}

searchExpenditure(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number) {  
  return this.http.get(this.baseurl + 'api/Expenditure/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
deleteExpenditure(expenditureId:number){   
  return this.http.delete(this.baseurl + 'api/Expenditure/DeleteExpenditure/'+expenditureId, this.httpOptions);
}
getAllexpenditureDetails(itemsPerPage: number, pageNo: number) {
return this.http.get(this.baseurl + 'api/Expenditure/GetAllexpenditureDetails/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
getexpenditureById(expenditureId: number) {
return this.http.get(this.baseurl + 'api/Expenditure/GetexpenditureById/' + expenditureId, this.httpOptions);
}
getAccountSubHeadByAccountHead(AccountHeadCode:any)
{
  return this.http.get(this.baseurl+'api/AccountSubHead/GetAccountSubHeadByAccountHead/'+AccountHeadCode,this.httpOptions);
}  
updatExpenditure(expenditure : Expenditure) {
  debugger;
  return this.http.put(this.baseurl + 'api/Expenditure/UpdateExpenditure', expenditure, this.httpOptions);
}    
addExpenditureDetails(expenditure : Expenditure )
{
  return this.http.post(this.baseurl + 'api/Expenditure/Create', expenditure, this.httpOptions);
}

//Sainik Schemes
getAllSainikSchemes(itemsPerPage: number, pageNo: number,serviceNo:any) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetAllSainikSchemes/' + itemsPerPage+"/"+pageNo+ "/"+serviceNo, this.httpOptions);
}  

addApplicationForm(sainikSchemeApplicationModel : SainikSchemeApplicationModel) {    
  return this.http.post(this.baseurl + 'api/SainikSchemes/Create', sainikSchemeApplicationModel, this.httpOptions);
}

getAllApplicationByTheUser(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetAllApplicationByTheUser/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
getSchemeApplicationDetailsById(applicationId: number) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetSchemeApplicationDetailsById/' + applicationId, this.httpOptions);
} 

getSchemeApplicationHistoryById(applicationId: number) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetSchemeApplicationHistoryById/' + applicationId, this.httpOptions);
} 
getOfficesApplicationBelongsTo(){
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetOfficesApplicationBelongsTo', this.httpOptions);
}
getAllUsersForOffice(officeId:number){
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetAllUsersForOffice/'+officeId, this.httpOptions);
}
getSainikApplicationStatus(){
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetSainikApplicationStatus', this.httpOptions);
}

getAllApplicationsToBeApprovedByTheUser(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetAllApplicationsToBeApprovedByTheUser/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
getAllApplicationsToBeApprovedByOthers(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetAllApplicationsToBeApprovedByOthers/' + itemsPerPage+"/"+pageNo, this.httpOptions);
} 
getAllApplicationsClosed(itemsPerPage:number,pageNo:number){  
  return this.http.get(this.baseurl + 'api/SainikSchemes/GetAllApplicationsClosed/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}
searchApplications(searchCriteria:any,searchText:any,itemsPerPage:number,pageNo: number,status:string) {
  return this.http.get(this.baseurl + 'api/SainikSchemes/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo+"/"+status, this.httpOptions);
}  
updateAppliationStatus(statusHistoryModel : SainikSchemeApplicationStatusHistoryModel) {
  debugger;
  return this.http.put(this.baseurl + 'api/SainikSchemes/UpdateSainikApplicationHistory', statusHistoryModel, this.httpOptions);
}  
searchCorrespondancingTracking(searchCriteria:any,searchText:any, itemsPerPage:number, pageNo: number)
{
  return this.http.get(this.baseurl + 'api/CorrespondanceTracking/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo, this.httpOptions);
}
AddCorrespondanceTracking(CorrespondanceTracking:any)
  {
     return this.http.post(this.baseurl + 'api/CorrespondanceTracking/AddCorrespondanceTracking',CorrespondanceTracking,this.httpOptions);
  }

  GetAllInwardOutwardDetailsinGrid(itemsPerPage: number, pageNo: number) 
{
  return this.http.get(this.baseurl + 'api/CorrespondanceTracking/GetAllInwardOutwardDetailsinGrid/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}
uploadcorrespondance(data:FormData) {
  debugger;
  return this.http.post(this.baseurl + 'api/CorrespondanceTracking/image' , data);
}
  GetInwardNo() 
  {
    return this.http.get(this.baseurl + 'api/CorrespondanceTracking/GetInwardNo/' , this.httpOptions);
  }
  GetOutwardNo()
  {
    return this.http.get(this.baseurl + 'api/CorrespondanceTracking/GetOutwardNo/',this.httpOptions);
  }
  GetAllInwardNoToGridbySP(itemsPerPage: number, pageNo: number) {
    return this.http.get(this.baseurl + 'api/CorrespondanceTracking/GetonlyInwardtoGrid/' + itemsPerPage+"/"+pageNo, this.httpOptions);
  }
  

  
GetInwardOutwardtoView(Id: any) 
{   
 debugger;
return this.http.get(this.baseurl + 'api/CorrespondanceTracking/GetByInwardOutwardNumber/' + Id, this.httpOptions);
}

updatecorrespondanceTrackingDetails(Id: Number,CorrespondanceTrackingModelDetails : CorrespondanceTrackingModel){    
  return this.http.put(this.baseurl + 'api/CorrespondanceTracking/UpdateCorrespondanceTrackingDetails/' + Id, CorrespondanceTrackingModelDetails, this.httpOptions);
}
AddSainikGrievances(grievancesLodging:GrievancesLodging)
{
  return this.http.post(this.baseurl + 'api/SainikGrievances/Create/' , grievancesLodging, this.httpOptions);
}
getAllGrievances(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/SainikGrievances/GetAllGrievances/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
getGrievanceById(Id:number)
{
  return this.http.get(this.baseurl+'api/SainikGrievances/GetGrievanceById/'+Id,this.httpOptions);    
}
searchGrievances(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{  
  return this.http.get(this.baseurl + 'api/SainikGrievances/Search/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
GetAllGrievancesByDistrictSearch(searchCriteria:any,searchText:any, itemsPerPage:number,pageNo:number)
{
  return this.http.get(this.baseurl + 'api/SainikGrievances/GetAllGrievancesByDistrictSearch/'+searchCriteria+"/"+searchText+"/"+itemsPerPage+"/"+pageNo,this.httpOptions);
}
getAllGrievancesByDistrict(itemsPerPage: number, pageNo: number) {
  return this.http.get(this.baseurl + 'api/SainikGrievances/GetAllGrievancesByDistrict/' + itemsPerPage+"/"+pageNo, this.httpOptions);
}  
UpdateSainikGrievances(grievancesLodging:GrievancesLodging)
{
  return this.http.put(this.baseurl + 'api/SainikGrievances/UpdateSainikGrievances/' , grievancesLodging, this.httpOptions);
}
  
    userAuthentication(user: Login) {    
      debugger;
      var data = "username=" + user.UserName + "&password=" + user.Password + "&grant_type=password" + "&OTP=" + user.OTP;
     /* const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' })
      }*/
      return this.http.post(this.baseurl + 'token', data);
    }


    //work flow alert

    getAllWorkFlowAlertForGrid(itemsPerPage: number, pageNo: number) {
      return this.http.get(this.baseurl + 'api/WorkFlowAlertController/GetAllDetailsForWorkFlowAlertGrid/' + itemsPerPage+"/"+pageNo, this.httpOptions);
    }  

    
    getAllUsersForGrievance()
    {
    return this.http.get(this.baseurl+'api/SainikGrievances/GetAllUsersForGrievance',this.httpOptions);    
    }
  

    //Grievance Lodging

    getBasicDetailsOfSainik(serviceNo:any)
    {
      debugger;
      return this.http.get(this.baseurl + 'api/SainikGrievances/GetBasicDetailsOfSainik/'+serviceNo,this.httpOptions);
    }

    getAllGrievancesByDistrictForBoth(itemsPerPage: number, pageNo: number) {
      return this.http.get(this.baseurl + 'api/SainikGrievances/GetAllGrievancesByDistrictBothGrievanceStatus/' + itemsPerPage+"/"+pageNo, this.httpOptions);
    }  


  //budget
    GetAllBudget(itemsPerPage: number, pageNo: number) {
      return this.http.get(this.baseurl + 'api/Budget/GetAllBudget/' + itemsPerPage+"/"+pageNo, this.httpOptions);
     } 
     //delete
     DeleteBudget(Budget_Year) {
       debugger;
      return this.http.delete(this.baseurl + 'api/Budget/DeleteBudget/' + Budget_Year, this.httpOptions);
    }
    //onSearchBudget
    onSearchBudget(searchCriteria: any, searchText: any, itemsPerPage: number, pageNo: number) {
      return this.http.get(this.baseurl + 'api/Budget/onSearchBudget/' + '/' + "/" + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/",this.httpOptions);
    }

    getAllAccountHeadSubHeadForBudget()
    {
    return this.http.get(this.baseurl+'api/Budget/GetAllAccountHeadSubHeadForBudget',this.httpOptions);    
    }

    //Save
    SaveBudgetDetails(budget:any,year:any)
    {
     // budget['Budget_Year'] = year;
      return this.http.post(this.baseurl + 'api/Budget/Create/'+year +"/",budget, this.httpOptions);
    }

    getBudgetDetailsByYear(Budget_Year: any) {
      return this.http.get(this.baseurl + 'api/Budget/' + Budget_Year, this.httpOptions);
    }
    //update budget
    updateBudgetDetails(budget:any,year:any)
    {
    return this.http.put(this.baseurl + 'api/Budget/Update/' +year +"/",budget, this.httpOptions);
    }

//approval
    GetApporvalDetailsForApproval(itemsPerPage: number, pageNo: number,type:any) {
      return this.http.get(this.baseurl + 'api/Approval/GetApporvalDetailsForApproval/' + itemsPerPage+"/"+pageNo +"/"+type, this.httpOptions);
    } 

    onSearchApproval(searchBy: any, searchValue: any, ItemsPerPage: number, pageno: number) {
      debugger;
      //return this.http.get(this.baseurl + 'api/Approval/GetAllApprovalOnSearch/' + '/' + "/" + itemsPerPage + "/" + pageNo + "/" + searchCriteria + "/" + searchText + "/" + type + "/",this.httpOptions);
      return this.http.get(this.baseurl + 'api/Approval/GetAllApprovalOnSearch/'+ ItemsPerPage + "/" + pageno + "/" + searchBy + "/" + searchValue,this.httpOptions);
    }
    GetAllApprovalForReject(itemsPerPage: number, pageNo: number,type:any) {
      return this.http.get(this.baseurl + 'api/Approval/GetAllApprovalForReject/' + itemsPerPage+"/"+pageNo +"/"+type, this.httpOptions);
    } 
    UpdateById(udm,ExpenditureId) {
      return this.http.put(this.baseurl + 'api/Approval/UpdateById/'+ExpenditureId, udm, this.httpOptions);
    }

    GetApporvalDetails(itemsPerPage: number, pageNo: number,type:any) {
      return this.http.get(this.baseurl + 'api/Approval/GetApporvalDetails/' + itemsPerPage+"/"+pageNo +"/"+type, this.httpOptions);
    } 

    
    // GetApporvalDetailsForApproval(itemsPerPage: number, pageNo: number,type:any) {
    //   return this.http.get(this.baseurl + 'api/Approval/GetApporvalDetailsForApproval/' + itemsPerPage+"/"+pageNo +"/"+type, this.httpOptions);
    // } 


    updateExpenditure(ExpenditureId,Ex_Status,Note) {
      return this.http.put(this.baseurl + 'api/Approval/UpdateExpenditureStatus/'+ExpenditureId+'/'+Ex_Status+'/'+Note, this.httpOptions);
    }

    //ExstatusbyId
    GetExpenditureStatusById(ExpenditureId:any) {
      return this.http.get(this.baseurl + 'api/Approval/GetExpenditureStatusById/' + ExpenditureId, this.httpOptions);
    }


    checkBudgetYearAlreadyExist(BudgetYear:any){  
      return this.http.get(this.baseurl+"api/Budget/CheckBudgetYearAlreadyExist/"+BudgetYear,this.httpOptions);
    }

 //Ranklevels
      saveRankLevels(data:any){  
        debugger;  
        return this.http.post(this.baseurl+"api/Masters/SaveRankLevels",data,this.httpOptions);
      }

      getAllRankLevels(itemsPerPage:number,pageNo:number) {
        debugger;
        return this.http.get(this.baseurl + 'api/Masters/GetAllRankLevels/' +itemsPerPage+"/"+pageNo, this.httpOptions);
      }

      getRankLevelById(RL_Id: any) {
        return this.http.get(this.baseurl + 'api/Masters/GetRankLevelById/' + RL_Id, this.httpOptions);
    }


    updateRankLevel(udm,RL_Id: any) {
      return this.http.put(this.baseurl + 'api/Masters/UpdateRankLevelId/'+RL_Id, udm, this.httpOptions);
    }

     //delete
     deleteRankLevel(RL_Id) {
       debugger;
       return this.http.put(this.baseurl + 'api/Masters/DeleteRankLevel/' + RL_Id,null, this.httpOptions);
   }

   //Military Operations
      saveMilitaryOperations(data:any){  
        return this.http.post(this.baseurl+"api/Masters/SaveMilitaryOperations",data,this.httpOptions);
      }

      getAllMilitaryOperations(itemsPerPage:number,pageNo:number) {
        debugger;
        return this.http.get(this.baseurl + 'api/Masters/GetAllMilitaryOperations/' +itemsPerPage+"/"+pageNo, this.httpOptions);
      }

      getOperationsById(Mil_OperationId: any) {
        return this.http.get(this.baseurl + 'api/Masters/GetOperationsById/' + Mil_OperationId,this.httpOptions);
    }

      updateMilitaryOperations(udm,Mil_OperationId: any) {
        return this.http.put(this.baseurl + 'api/Masters/UpdateOperationsById/'+Mil_OperationId,udm,this.httpOptions);
      }

      //delete
      deleteMilitaryOperation(Mil_OperationId) {
        return this.http.put(this.baseurl + 'api/Masters/DeleteMilitaryOperation/' + Mil_OperationId,null,this.httpOptions);
    }

  //Stations
    savestations(data:any)
    {
      return this.http.post(this.baseurl + 'api/Masters/AddStations', data, this.httpOptions);
    }
    
    getAllstations(itemsPerPage:number,pageNo:number) {
     debugger;
     return this.http.get(this.baseurl + 'api/Masters/GetAllStations/' +itemsPerPage+"/"+pageNo, this.httpOptions);
   }
 
   getstationsById(Station_Id:any)
   {
     return this.http.get(this.baseurl + 'api/Masters/GetById/' + Station_Id, this.httpOptions);
   }

   updateStationsById(udm,Station_Id: any) {
    return this.http.put(this.baseurl + 'api/Masters/UpdateStationsById/'+Station_Id, udm, this.httpOptions);
  }

   //delete
   deleteStation(Station_Id) {
    return this.http.put(this.baseurl + 'api/Masters/DeleteStation/' + Station_Id,null,this.httpOptions);
  }

//Pension Issuing Authority Master
    savePensionIssuingAuthorityDetails(data:any){  
      return this.http.post(this.baseurl+"api/Masters/SavePensionIssuingAuthorityDetails",data,this.httpOptions);
    }

    getAllPIAForMasters(itemsPerPage:number,pageNo:number) {
      return this.http.get(this.baseurl + 'api/Masters/GetAllPensionAuthorityDetails/' +itemsPerPage+"/"+pageNo, this.httpOptions);
    }

    getPensionAuthorityDetailsById(PIA_Id:any)
    {
      return this.http.get(this.baseurl + 'api/Masters/GetPensionAuthorityDetailsById/' + PIA_Id, this.httpOptions);
    }

    updatePensionIssuingAuthorityDetails(udm,PIA_Id: any) {
      return this.http.put(this.baseurl + 'api/Masters/UpdatePensionIssuingAuthorityDetails/'+PIA_Id, udm, this.httpOptions);
    }
    //delete
    deletePensionIssuingAuthorityDetails(PIA_Id) {
      return this.http.put(this.baseurl + 'api/Masters/DeletePensionIssuingAuthorityDetails/' + PIA_Id,null,this.httpOptions);
  }

  //Stations dropdown
  getAllStationsOfRecordOfficeAddress(){    
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetAllStationsOfRecordOfficeAddress",this.httpOptions);
  }

  //MilitaryOperation dropdown

  getAllMilitaryOperationsForcasualtyYear(Year){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetAllMilitaryOperations/"+ Year,this.httpOptions);
  }


  getMilitaryOperationsForDropdown(){
    return this.http.get(this.baseurl+"api/SainikBattleCasualty/GetMilitaryOperationsForDropdown/",this.httpOptions);
  }
  

  //districts dropdown
  getallDistrictsForBankDetails(){  
    return this.http.get(this.baseurl+"api/SainikBankDetails/GetDistrictsForBankDetails",this.httpOptions);
  }

//getallpensiontypes
  getAllPensionTypesForPension(){  
    return this.http.get(this.baseurl+"api/SainikPension/GetAllPensionTypesForPension",this.httpOptions);
  }

  getSainikDetailsForDependentIdCard(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetSainikDetailsForDependentIdCard/"+serviceNo,this.httpOptions);
  }

  getExServiceManIdCardDetails(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetExServiceManIdCardDetails/"+serviceNo,this.httpOptions);
  }

  getWidowIdCardDetails(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetWidowIdCardDetails/"+serviceNo,this.httpOptions);
  }
 
  getMarriageGrantOfDaughterFormDetails(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetMarriageGrantOfDaughterFormDetails/"+serviceNo,this.httpOptions);
  }

  getDetailsForSpectacleGrantForm(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetSpectacleGrantFormDetails/"+serviceNo,this.httpOptions);
  }

  getDetailsForCETCertificateForm(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetCETCertificateFormDetails/"+serviceNo,this.httpOptions);
  }
  getDetailsForEmploymentRegistrationform(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForEmploymentRegistrationform/"+serviceNo,this.httpOptions);
  }
  getDetailsForHouseRepairGrantform(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForHouseRepairGrantform/"+serviceNo,this.httpOptions);
  }

  getDetailsForStateGovtScholarshipform(serviceNo:any){
    return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForStateGovtScholarshipform/"+serviceNo,this.httpOptions);
  }

  //Schemes Save DependentIdCard details
  saveDependentIdCardDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveDependentIdCardDetails",data,this.httpOptions);
  }

  //Schemes Save ESMIdCard details
  saveESMIdCardDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveESMIdCardDetails",data,this.httpOptions);
  }

  //Schemes Save WidowIdCard details
  saveWidowIdCardDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveWidowIdCardDetails",data,this.httpOptions);
  }

  //Schemes Save MarriageGrantdetails
  saveMarriageGrantFormDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveMarriageGrantFormDetails",data,this.httpOptions);
  }
  //Schemes Save SpectacleGrantdetails
  saveSpectacleGrantFormDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveSpectacleGrantFormDetails",data,this.httpOptions);
  }
   //Schemes Save Issue of Cet Certificateform Details
  saveCETCertificateFormDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveCETCertificateFormDetails",data,this.httpOptions);
  }

  //Save EmployeeRegistrationform Details
  saveEmploymentRegistrationFormDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveEmployeeRegistrationformDetails",data,this.httpOptions);
  }
  //SaveHouseRepairGrantformDetails
  saveHouseRepairGrantformDetails(data:any){  
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveHouseRepairGrantformDetails",data,this.httpOptions);
  }

  //appl9 StateGovtscholarshipSave
   saveStateGovtScholarshipDetails(data:any){  
      return this.http.post(this.baseurl+"api/SainikSchemes/SaveStateGovtScholarshipDetails",data,this.httpOptions);
    }

    //appl10 ChildrenScholarshipGrant
    saveChildrenScholarshipGrantDetails(data:any){  
      return this.http.post(this.baseurl+"api/SainikSchemes/SaveChildrenScholarshipGrant",data,this.httpOptions);
    }

    //GetChildrenscholarshipgrant
    getDetailsForChildrenGrantScholarshipform(serviceNo:any){
      return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForChildrenGrantScholarshipform/"+serviceNo,this.httpOptions);
    }

    //GetDetailsForGallantryNonGallantryform
    getDetailsForGallantryNonGallantryform(serviceNo:any){
      return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForGallantryNonGallantryform/"+serviceNo,this.httpOptions);
    }

    //appl12 getDetailsForDeathReliefGrantform
    getDetailsForDeathReliefGrantform(serviceNo:any){
      return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForDeathReliefGrantform/"+serviceNo,this.httpOptions);
    }

    //appl13 getDetailsForCashAwardform
    getDetailsForCashAwardform(serviceNo:any){
      return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForCashAwardform/"+serviceNo,this.httpOptions);
    }

      //appl14 getDetailsForAnnualReliefGrantForm
      getDetailsForAnnualReliefGrantForm(serviceNo:any){
        return this.http.get(this.baseurl+"api/SainikSchemes/GetDetailsForAnnualReliefGrantForm/"+serviceNo,this.httpOptions);
      }

    //appl11 SaveGallantryNonGallantryFormDetails
    saveGallantryNonGallantryFormDetails(data:any){  
      return this.http.post(this.baseurl+"api/SainikSchemes/SaveGallantryNonGallantryFormDetails",data,this.httpOptions);
    }

    //appl12 SaveDeathReliefGrantFormDetails
    saveDeathReliefGrantFormDetails(data:any){  
      return this.http.post(this.baseurl+"api/SainikSchemes/SaveDeathReliefGrantFormDetails",data,this.httpOptions);
    }

    //appl13 SaveCashAwardFormDetails
    saveCashAwardFormDetails(data:any){  
      return this.http.post(this.baseurl+"api/SainikSchemes/SaveCashAwardFormDetails",data,this.httpOptions);
    }

    //appl14 saveAnnualReliefGrantFormDetails
    saveAnnualReliefGrantFormDetails(data:any){  
      return this.http.post(this.baseurl+"api/SainikSchemes/SaveAnnualReliefGrantformDetails",data,this.httpOptions);
    }

  //Scheme Approval approve
  updateSchemeApprovalStatus(applicationId:any,StatusId: any,Comments:any,fromUserId:any) {
    return this.http.put(this.baseurl + 'api/SainikSchemes/UpdateSchemeApprovalStatus/'+applicationId+'/'+ StatusId +'/'+Comments+'/'+fromUserId ,null, this.httpOptions);
  }


  //GetAllUsersForSchemeApprovals

  // getAllUsersForSchemeApprovals()
  // {
  // return this.http.get(this.baseurl+'api/SainikSchemes/GetAllUsersForSchemeApprovals',this.httpOptions);    
  // }

  //SaveSchemeApplication Approved
  saveSchemeApplicationApproved(applicationId:any,data:any){  
    data.ApplicationId=applicationId;
    return this.http.post(this.baseurl+"api/SainikSchemes/SaveSchemeApprovalStatus",data,this.httpOptions);
  }
  
  CreateOfficeDistrict(office) {
    return this.http.post(this.baseurl + 'api/Offices/CreateOfficeDistrict', office, this.httpOptions);
  } 
  GetAllDistrictNamesListgrid(id:any) {
    debugger;
    return this.http.get(this.baseurl + 'api/Offices/GetDistrictOffice/'+id, this.httpOptions);
  } 

  GetAllDistrictNamesListgrid2(id:any) {
    debugger;
    return this.http.get(this.baseurl + 'api/Offices/GetDistrictOffice2/'+id, this.httpOptions);
  } 

  dleteOffcdistrict(id: any) {
    return this.http.put(this.baseurl + 'api/Offices/DeleteOffdistrict/'+id,null, this.httpOptions);
  }

  // Rohit New 

  GetAllDependentsBySainikId(string: any) {
    return this.http.get(this.baseurl + 'api/SainikDependents/GetAllDependentsBySainikId/'+ string,this.httpOptions);
  }

  GetDependentDetailById(string: any, id:any) {
    return this.http.get(this.baseurl + 'api/SainikDependents/GetDependentDetailById/'+string+'/'+id,this.httpOptions);
  }

  GetAllDocumentTypesDep(){    
    return this.http.get(this.baseurl+"api/SainikDependents/GetAllDocumentTypesDep",this.httpOptions);
  }
  
  GetDependentDocDetail_Grid(int: any, id:any){
    return this.http.get(this.baseurl+'api/SainikDependents/GetDependentDocDetail_Grid/'+int+'/'+id,this.httpOptions);
  }  
 
 SaveDependentsDocUploads(data:any,serviceNo:any,SD_Id:any) {
 // debugger;  
  return this.http.post(this.baseurl+"api/SainikDependents/"+serviceNo+"/"+SD_Id, data,this.httpOptions);
 }

 DeleteDependentsDocUploads(DuploadId:any){
 // debugger;   
  return this.http.put(this.baseurl+"api/SainikDependents/DeleteDependentsDocUploads/"+DuploadId,null,this.httpOptions);
 }

   //rohit viewform
   getRegSainikCompleteDetails(SR_ServiceNo:any){    
    return this.http.get(this.baseurl+"api/SainikBasicRegistration/GetRegSainikViewForm/"+SR_ServiceNo,this.httpOptions);
  }


}





// WEBPACK FOOTER //
// ./src/app/registration.service.ts